import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    HomePageCarouselPromosComponent,
    HomePageCarouselPromosListWrapper,
    HomePageCarouselSingleItem,
    SliderWrapper,
} from './HomePageCarouselPromos.style';
import { range } from 'lodash';
import { CarouselLoader } from 'src/domains/layouts/shared/loaders';

const noOfPlaceholders = 6;

export const HomePageCarouselLoader = observer('HomePageCarouselLoader', (): JSX.Element => {
    return (
        <HomePageCarouselPromosComponent
            isDot={true}
            isHomePage={true}
        >
            <HomePageCarouselPromosListWrapper data-test='homepage-carousel-wrapper'>
                <SliderWrapper calcShift={0}>
                    {range(0, noOfPlaceholders).map((i) => (
                        <HomePageCarouselSingleItem key={i}>
                            <CarouselLoader />
                        </HomePageCarouselSingleItem>
                    ))}
                </SliderWrapper>
            </HomePageCarouselPromosListWrapper>
        </HomePageCarouselPromosComponent>
    );
});
